import type { ObjectId } from '@freightview/object-id'

export const ALL_CONTACTS_GROUP_ID = '62696dfa94bcbd76265856a2'
export const UNGROUPED_CONTACTS_ID = '62696dfa94bcbd76265856a0'

export interface SpotQuoteContact {
  userId: ObjectId
  groups?: string[]
}

export interface ExpandedSpotQuoteContact {
  carrierId?: ObjectId
  carrierName?: string
  email?: string
  name?: string
  userId: ObjectId
  groups?: string[]
  requiresQuoteNumber?: boolean
  supportsTLFreightCollect?: boolean
}

export interface UpsertSpotQuoteContactDto {
  emails: string[]
}
